import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "../../../helpers/classNames";
const DraggableSvg = ({ item: { props: { className, svgContent, ...restProps }, id, }, elementId, ...rest }) => {
    return (_jsx("svg", { className: classNames(className), "editor-type": "svg", "editor-key": id, ...restProps, ...rest, dangerouslySetInnerHTML: {
            __html: svgContent,
        } }));
};
export default DraggableSvg;
//# sourceMappingURL=DraggableSvg.js.map